import {Component} from '@angular/core';

@Component({
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent {}
